import React from "react";
import { Form, Button, Container } from "react-bootstrap";
import {
  AttendanceHistoryFilterInput,
  ChapterInvolvementFilterInput,
  CommitteeCreditFilterInput,
  NegativeFilterInput,
  SocialsFilterInput,
  VivoFilterInput,
  WorkShopsFilterInput,
} from "./FilterInput";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useFilterMember } from "../../../hooks/useFilterMember";
import { PaymentFilterDropdown } from "./DropdownField";

const FilterField = () => {
  const { startQuery } = useFilterMember();

  const handleSearch = (event) => {
    event.preventDefault();
    startQuery();
  };

  return (
    <Form onSubmit={handleSearch} className="mb-4">
      <Container>
        <Row xl={4} lg={3} md={2} xs={1}>
          <Col className="my-1">
            <VivoFilterInput />
          </Col>
          <Col className="my-1">
            <CommitteeCreditFilterInput />
          </Col>
          <Col className="my-1">
            <WorkShopsFilterInput />
          </Col>

          <Col className="my-1">
            <NegativeFilterInput />
          </Col>

          <Col className="my-1">
            <AttendanceHistoryFilterInput />
          </Col>

          <Col className="my-1">
            <SocialsFilterInput />
          </Col>
          <Col className="my-1">
            <PaymentFilterDropdown />
          </Col>

          <Col className="my-1">
            <ChapterInvolvementFilterInput />
          </Col>
        </Row>

        <Button variant="primary" type="submit" className="mt-1">
          Search
        </Button>
      </Container>
    </Form>
  );
};

export default FilterField;
